<div class="wrapper ui-scrollbar">
  @let _groupedNotifications = groupedNotifications();
  @for (group of _groupedNotifications; track group.label) {
    <ui-label
      class="group-label"
      type="secondary">
      {{ group.label }}
    </ui-label>
    @for (notification of group.notifications; track notification.id) {
      <ns-notification-item
        [notification]="notification"
        (linkClicked)="handleLinkClicked()"
        (notificationClicked)="handleNotificationClicked($event)" />
    }
  } @empty {
    <div class="empty-state">
      <ui-svg-icon
        icon="none"
        nuiIcon="check_circle"
        size="lg" />
      <h3
        nuiTypography="nui-title"
        uiSize="md">
        You're all caught up
      </h3>
      <p
        nuiTypography="nui-body"
        uiSize="sm">
        You have no unread notifications
      </p>
    </div>
  }
</div>
